@if (!isPG()) {
	<div class="py-6 text-sm border-b border-gray-200">
		<p class="pb-2 font-medium text-gray-700">{{ heading() }}</p>
		<uc-clearing-toggle
			[isClearing]="isCLE()"
			(checked)="changeClearingChecked.emit($event)"
			customStyles="text-gray-900"
		/>
		<p class="pt-1 text-gray-500">{{ formattedDesc() }}</p>
	</div>
}
